import { render, staticRenderFns } from "./verificationCode.vue?vue&type=template&id=164d4de7&scoped=true&"
import script from "./verificationCode.vue?vue&type=script&lang=js&"
export * from "./verificationCode.vue?vue&type=script&lang=js&"
import style0 from "./verificationCode.vue?vue&type=style&index=0&id=164d4de7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164d4de7",
  null
  
)

export default component.exports